import request from '@/utils/request'


// 查询直播列表
export function listCommunityLive(query) {
  return request({
    url: '/community/admin/community/live/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询直播分页
export function pageCommunityLive(query) {
  return request({
    url: '/community/admin/community/live/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询直播详细
export function getCommunityLive(data) {
  return request({
    url: '/community/admin/community/live/detail',
    method: 'get',
    params: data
  })
}

// 新增直播
export function addCommunityLive(data) {
  return request({
    url: '/community/admin/community/live/add',
    method: 'post',
    data: data
  })
}

// 修改直播
export function updateCommunityLive(data) {
  return request({
    url: '/community/admin/community/live/edit',
    method: 'post',
    data: data
  })
}

// 修改直播商品
export function updateCommunityLiveGoods(data) {
  return request({
    url: '/community/admin/community/live/goods/edit',
    method: 'post',
    data: data
  })
}

export function recommendCommunityLiveGoods(data) {
  return request({
    url: '/community/admin/community/live/goods/recommend',
    method: 'post',
    data: data
  })
}

export function communityLiveGoodsList(data) {
  return request({
    url: '/community/admin/community/live/goods/list',
    method: 'post',
    data: data
  })
}

// 删除直播
export function delCommunityLive(data) {
  return request({
    url: '/community/admin/community/live/delete',
    method: 'post',
    data: data
  })
}

export function communityLiveStart(data) {
  return request({
    url: '/community/admin/community/live/start',
    method: 'post',
    data: data
  })
}

export function communityLiveEnd(data) {
  return request({
    url: '/community/admin/community/live/end',
    method: 'post',
    data: data
  })
}
